import { render } from "./HomeBaseHouseHolds.vue?vue&type=template&id=612d515e"
import script from "./HomeBaseHouseHolds.vue?vue&type=script&lang=js"
export * from "./HomeBaseHouseHolds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__